import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import AccessoryItem from './item';
import RaisedButton from 'material-ui/RaisedButton';
import PrepareOrder from './../../prepare-order';
import { createOrder } from './../../../../../actions/firebase/orders';

const CategoryAccessories = props => {
  const { ids, status, qty, handleQty, setStatusBlank, sendOrder, setStatusPrepare, incrQty, decrQty } = props;
  const qtyIsValid = () => {
    let total = 0;
    if (Object.keys(qty).length === 0)
      return false;
    Object.keys(qty).forEach(key => {
      total += qty[key];
    });
    return total > 0;
  };
  return (
    <div>
      <div style={{marginLeft: '12px', marginTop: '12px'}}>
        <div>
          {(status === 'blank' || status === 'sent') &&
            <RaisedButton
              label='Заказать'
              labelStyle={{fontWeight: 'normal'}}
              onClick={setStatusPrepare}
            />
          }
          {status === 'prepare' &&
            <RaisedButton
              labelStyle={{fontWeight: 'normal'}}
              label='Отправить заказ'
              onClick={sendOrder}
              disabled={!qtyIsValid()}
            />
          }
          {status === 'prepare' &&
            <RaisedButton
              style={{marginLeft: '4px'}}
              label='Отмена'
              labelStyle={{fontWeight: 'normal'}}
              onClick={setStatusBlank}
            />
          }
        </div>
      </div>
      <div style={{width: '300px', padding: '20px'}}>
        {status === 'prepare' &&
          <PrepareOrder forAccessories={true} />
        }
      </div>
      <div style={{display: 'flex', flexWrap: 'wrap'}}>
        {
          ids.map(id => {
            return (
              <AccessoryItem key={`accessoryItem${id}`} id={id} qty={qty[id] || 0} handleQty={handleQty} status={status} incrQty={incrQty} decrQty={decrQty} />
            )
          })
        }
      </div>
    </div>
  );
}

class CategoryAccessoriesContainer extends Component {
  constructor() {
    super();
    this.state = { status: 'blank', qty: {}, comment: '', orderNr: '' };
  }
  static propTypes = {
    ids: PropTypes.array
  }
  static defaultProps = {
    ids: []
  }
  setStatusBlank = () => {
    this.setState({ status: 'blank'});
  }
  setStatusPrepare = () => {
    this.setState({ status: 'prepare'}, () => {
      this.props.dispatch({ type: 'SET_ORDER_SET_ID', p: '' });
    });
  }
  sendOrder = () => {
    const accessories = Object.keys(this.state.qty).reduce((res, key) => {
      if (this.state.qty[key] > 0) {
        res[key] = this.state.qty[key];
      };
      return res;
    }, {});
    this.props.dispatch(createOrder({ accessories }));
  }
  handleQty = (id, v) => {
    const val = parseInt(v, 10) || 0;
    val >= 0 && this.setState({ qty: { ...this.state.qty, [id]: val } });
  }
  handleComment = (id, v) => {
    this.setState({ comment: v });
  }
  incrQty = id => {
    const curQty = this.state.qty[id] || 0;
    this.setState({ qty: { ...this.state.qty, [id]: curQty + 1 } });
  }
  decrQty = id => {
    const curQty = this.state.qty[id] || 0;
    curQty > 0 && this.setState({ qty: { ...this.state.qty, [id]: curQty - 1 } });
  }
  render () {
    return (
      <CategoryAccessories
        ids={this.props.ids}
        status={this.state.status}
        qty={this.state.qty}
        handleQty={this.handleQty}
        setStatusBlank={this.setStatusBlank}
        setStatusPrepare={this.setStatusPrepare}
        sendOrder={this.sendOrder}
        incrQty={this.incrQty}
        decrQty={this.decrQty}
      />
    )
  }
}

export default connect(
  (state, ownProps) => {
    let ids = [];
    if (ownProps.ids) {
      return { ids: ownProps.ids };
    }
    if (ownProps.for) {
      switch (ownProps.for) {
        case 'category':
          const { category } = state.ui;
          const curCategoryAccessories = state.categoryAccessories[category] || {};
          ids = Object.keys(curCategoryAccessories).reduce((res, key) => res.concat(curCategoryAccessories[key]), []);
          return {ids};
        case 'set':
          const { set } = state.ui;
          const curSetAccessories = state.sets[set].accessories || {};
          ids = Object.keys(curSetAccessories).reduce((res, key) => res.concat(curSetAccessories[key]), []);
          return {ids};
        default:
          return {ids};
      }
    }
    return {ids};
  },
)(CategoryAccessoriesContainer);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/accessories-kiosk/list.js